import React, {useEffect} from 'react';
import DialogMUI from '../../../shared/DialogMUI';
import {useDispatch, useSelector} from 'react-redux';
import {closeModal} from '../../../redux/actions/app/appActions';

import './EmployeesMultiAdd.scss';
import {useTranslation} from 'react-i18next';
import {POPUPS} from "../../../redux/actions/app/appActionTypes";
import {AutocompleteMUI, ButtonMUI, LoaderMUI} from "../../../shared";
import {useForm, Controller} from "react-hook-form";
import * as yup from 'yup';
import {yupResolver} from "@hookform/resolvers/yup";
import {
    getCompanyEmployeeInner,
    getEmployeeAddList,
    postEmployeeAddProjects
} from "../../../redux/actions/employee/employeeActions";
import {notifySuccess} from "../../../helpers/notifySnack";

const EmployeesMultiAdd = () => {

    const dispatch = useDispatch();
    const {t} = useTranslation();
    const popupToShow = useSelector(({app}) => app.popupToShow);
    const popupVisible = popupToShow === POPUPS.MULTI_EMPLOYEE_POPUP;
    const {employeeAdd, employeeAddLoading, companyEmployeesInner} = useSelector((state) => state.employee);
    const {singleCompany} = useSelector((state) => state.company);

    const employeesArr = employeeAdd?.map(project => {
        return {
            id: project.id,
            label: project.address,
            text: project?.city?.name || '',
            avatar: project?.logo || ''
        }
    })

    const validationSchema = yup.object().shape({
        projectsId: yup.array()
            .min(1, 'Виберіть хоча б один проєкт')
            .required(t('profileSettings.required')),
    });


    const {
        control,
        handleSubmit,
        reset,
        formState: {errors, isSubmitting},
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            projectsId: [],
        }
    });


    const onCloseHandler = () => {
        reset({
            projectsId: [],
        })
        dispatch(closeModal());
    };

    const onSubmit = async (data) => {
        const formData = new FormData();
        formData.append(`employeeId`, companyEmployeesInner?.employeeId);

        data.projectsId.forEach((project, idx) => {
            formData.append(`projects[${idx}]`, project?.id);
        })


        const res = await dispatch(postEmployeeAddProjects(singleCompany?.id, formData))

        if (res?.payload) {
            onCloseHandler();
            await dispatch(getCompanyEmployeeInner(singleCompany?.id, companyEmployeesInner?.employeeId));
            notifySuccess(t('all.successfully'));
        }
    };

    useEffect(() => {
        if (popupVisible) {
            if (companyEmployeesInner?.employeeId && singleCompany?.id)
                dispatch(getEmployeeAddList(singleCompany.id, companyEmployeesInner.employeeId));
        }
    }, [popupVisible, singleCompany?.id, companyEmployeesInner?.employeeId]);


    return (
        <DialogMUI
            maxWidth={'sm'}
            fullWidth={true}
            open={popupVisible}
            onClose={onCloseHandler}
            title={t('all.addToProjects')}
        >
            {employeeAddLoading ? <LoaderMUI noBg={true} staticPos={true}
                                             circleSize={40}/> : <form onSubmit={handleSubmit(onSubmit)}>
                <Controller
                    name='projectsId'
                    control={control}
                    render={({field}) => (
                        <AutocompleteMUI
                            className='no-icons'
                            text={t('ProjectsModal.selectFromList')}
                            array={employeesArr}
                            error={errors?.projectsId}
                            value={field.value}
                            onChange={field.onChange}
                        />
                    )}
                />

                <div className="employees-multi-btn">
                    <ButtonMUI type="submit" disabled={isSubmitting}>
                        {t('ProjectsParticipantsAdd.add')}
                    </ButtonMUI>
                </div>
            </form>}

        </DialogMUI>
    );
};

export default EmployeesMultiAdd;
